// Device-level favourites (no account needed): starred places and starred vault shows.
import { useCallback, useEffect, useState } from "react";

const read = (key) => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; } };

// Returns { items: {id: meta}, has(id), toggle(id, meta), count }
export const useFavs = (key) => {
  const [items, setItems] = useState(() => read(key));
  useEffect(() => {
    const onStorage = (e) => { if (e.key === key) setItems(read(key)); };
    const onLocal = (e) => { if (e.detail === key) setItems(read(key)); };
    window.addEventListener("storage", onStorage); window.addEventListener("wall:favs", onLocal);
    return () => { window.removeEventListener("storage", onStorage); window.removeEventListener("wall:favs", onLocal); };
  }, [key]);
  const toggle = useCallback((id, meta = {}) => {
    const cur = read(key);
    if (cur[id]) delete cur[id]; else cur[id] = { ...meta, saved_at: Date.now() };
    localStorage.setItem(key, JSON.stringify(cur));
    setItems({ ...cur });
    window.dispatchEvent(new CustomEvent("wall:favs", { detail: key }));
  }, [key]);
  return { items, has: (id) => !!items[id], toggle, count: Object.keys(items).length };
};

export const FAV_PLACES = "wall_fav_places";
export const FAV_SHOWS = "wall_vault_favs";
